// extracted by mini-css-extract-plugin
export default {"accountHeader":"Tl-z","newDesignAccountHeader":"Ul-z","primeBadge":"Vl-z","logout":"Wl-z"};